import i18n from '../locales/index'
import { downloadImg } from "./util"

export const formatDateTime = (h, display_time) => {
  return h('div', [
    h('span', {
      directives: [
        {
          name: 'time_format3',
          value: display_time
        }
      ]
    })
  ])
}

export const formatDate = (h, display_time) => {
  return h('div', [
    h('span', {
      directives: [
        {
          name: 'time_format',
          value: display_time
        }
      ]
    })
  ])
}

export const booleanChinese = (h, bool) => {
  let color, text
  if (bool) {
    color = 'green'
    text = i18n.t('libs_table_render_50')
  } else {
    color = 'red'
    text = i18n.t('directives_index_41')
  }
  return tagColor(h, color, text)
}

export const comeFromChinese = (h, come_from) => {
  let color, text
  if (come_from === 'front') {
    color = 'green'
    text = i18n.t('libs_table_render_51')
  } else if (come_from === 'wechat_mini') {
    color = 'red'
    text = i18n.t('libs_table_render_52')
  } else if (come_from === 'h5') {
    color = 'yellow'
    text = 'H5'
  } else if (come_from === 'scan_desk') {
    color = 'orange'
    text = i18n.t('libs_table_render_53')
  }
  return tagColor(h, color, text)
}

export const orderTypeChinese = (h, order_type) => {
  let text
  if (order_type === 'user_fetch') {
    text = i18n.t('libs_table_render_54')
  } else if (order_type === 'merchant_send') {
    text = i18n.t('libs_table_render_55')
  } else if (order_type === 'takeout') {
    text = i18n.t('libs_table_render_56')
  } else if (order_type === 'express') {
    text = i18n.t('libs_table_render_57')
  } else if (order_type === 'inner_eat') {
    text = i18n.t('libs_table_render_58')
  }

  return h ? h('div', {}, text) : text
}

export const paymentChinese = (h, payment_method) => {
  let color, text
  if (payment_method === 'unpaid' || payment_method === 'ordering') {
    color = 'red'
    text = i18n.t('libs_table_render_59')
  } else if (payment_method === 'refund') {
    color = 'pink'
    text = i18n.t('libs_table_render_60')
  } else if (payment_method === 'pending') {
    color = 'pink'
    text = i18n.t('libs_table_render_61')
  } else if (payment_method === 'paid') {
    color = 'green'
    text = i18n.t('libs_table_render_62')
  } else if (payment_method === 'unreceived') {
    color = 'blue'
    text = i18n.t('libs_table_render_63')
  } else if (payment_method === 'unreviewed') {
    color = 'yellow'
    text = i18n.t('libs_table_render_64')
  } else if (payment_method === 'finished') {
    color = 'cyan'
    text = i18n.t('libs_table_render_65')
  } else if (payment_method === 'cancelled') {
    color = 'grey'
    text = i18n.t('libs_table_render_66')
  } else if (payment_method === 'waiting_confirmed') {
    color = 'orange'
    text = i18n.t('libs_table_render_67')
  } else if (payment_method === 'refunded') {
    color = 'gray'
    text = i18n.t('libs_table_render_60')
  } else if (payment_method === 'discarded') {
    color = 'gray'
    text = i18n.t('libs_table_render_68')
  }
  return tagColor(h, color, text)
}

export const tagColor = (h, color, text) => {
  return h(
    'Tag',
    {
      props: {
        color: color
      }
    },
    text
  )
}

export const tableAvatar = (h, avatar) => {
  if (avatar) {
    return h('img', {
      attrs: {
        src: avatar,
        width: 60,
        height: 60
      }
    })
  }
}

export const tableAvatar2 = (h, avatar) => {
  if (avatar) {
    return h('img', {
      attrs: {
        src: avatar,
        width: 120,
        height: 120
      }
    })
  }
}

export const tableVideo = (h, url) => {
  console.info(h, url)
  if (url) {
    return h('video', {
      attrs: {
        src: url,
        width: 60,
        height: 60
      }
    })
  }
}

export const deleteButtonInTable = (vm, h, params) => {
  return h(
    'Poptip',
    {
      props: {
        confirm: true,
        title: i18n.t('libs_table_render_69'),
        transfer: true
      },
      on: {
        'on-ok': () => {
          vm.destroy(params.row.id)
        }
      }
    },
    [
      h(
        'Button',
        {
          style: {
            margin: '2px 5px'
          },
          props: {
            type: 'error',
            placement: 'top'
          }
        },
        i18n.t('libs_table_render_70')
      )
    ]
  )
}

export const editorButtonInTable = (vm, h, params) => {
  return h(
    'Button',
    {
      props: {
        type: 'info'
      },
      style: {
        margin: '2px 5px'
      },
      on: {
        click: async () => {
          vm.formType = 'edit'
          vm.modalShow = true
          vm.show(params.row.id)
        }
      }
    },
    i18n.t('libs_table_render_71')
  )
}
export const syncButtonInTable = (vm, h, params) => {
  return h(
    'Button',
    {
      props: {
        type: 'info'
      },
      style: {
        margin: '2px 5px'
      },
      on: {
        click: async () => {
          vm.targetSyncId(params.row.id)
          vm.$refs.syncDataShop.show()
        }
      }
    },
    i18n.t('libs_table_render_72')
  )
}
export const syncShopsButtonInTable = (vm, h, params) => {
  return h(
    'Button',
    {
      props: {
        type: 'info'
      },
      style: {
        margin: '2px 5px'
      },
      on: {
        click: async () => {
          vm.targetSyncId(params.row.id)
          vm.$refs.syncDataShops.show()
        }
      }
    },
    i18n.t('libs_table_render_73')
  )
}

export const commonButtonInTable = (vm, h, style, title, action, params) => {
  return h(
    'Button',
    {
      props: {
        type: style
      },
      style: {
        margin: '2px 5px'
      },
      on: {
        click: () => {
          action(...params)
        }
      }
    },
    title
  )
}

export const commonButtonInTable2 = (vm, h, props, title, action, params) => {
  return h(
    'Button',
    {
      props,
      style: {
        margin: '2px 5px'
      },
      on: {
        click: () => {
          action(...params)
        }
      }
    },
    title
  )
}

export const podStatus = (h, status) => {
  let color, text
  if (status === 'cash_pay') {
    color = 'green'
    text = i18n.t('libs_table_render_74')
  } else if (status === 'svc_pay') {
    color = 'pink'
    text = i18n.t('libs_table_render_75')
  } else if (status === 'lcsw_wx_pay') {
    color = 'green'
    text = i18n.t('libs_table_render_76')
  } else if (status === 'lcsw_ali_pay') {
    color = 'blue'
    text = i18n.t('libs_table_render_77')
  } else if (status === 'bank_card') {
    color = 'red'
    text = i18n.t('libs_table_render_78')
  } else if (status === 'alipay_offline') {
    color = 'blue'
    text = i18n.t('libs_table_render_79')
  } else if (status === 'wx_pay_offline') {
    color = 'green'
    text = i18n.t('libs_table_render_80')
  } else if (status === 'meituan_pay_offline') {
    color = 'yellow'
    text = i18n.t('libs_table_render_81')
  } else if (status === 'scan_code_pay') {
    color = 'cyan'
    text = i18n.t('libs_table_render_82')
  }
  return text ? tagColor(h, color, text) : h('div', {}, '--');
}

export const bannerPlatform = (h, status) => {
  let color, text
  if (status === 'mini') {
    color = 'green'
    text = i18n.t('libs_table_render_52')
  } else if (status === 'front') {
    color = 'pink'
    text = i18n.t('libs_table_render_51')
  } else if (status === 'splash') {
    color = 'yellow'
    text = i18n.t('libs_table_render_83')
  } else if (status === 'windows') {
    color = 'red'
    text = i18n.t('libs_table_render_84')
  } else {
    color = 'black'
    text = i18n.t('libs_table_render_85')
  }
  return tagColor(h, color, text)
}

export const bannerCategory = (h, status) => {
  let color, text
  if (status === 'picture') {
    color = 'blue'
    text = i18n.t('libs_table_render_86')
  } else if (status === 'video') {
    color = 'red'
    text = i18n.t('libs_table_render_87')
  } else {
    color = 'black'
    text = i18n.t('libs_table_render_85')
  }
  return tagColor(h, color, text)
}
export const weekText = (week) => {
  const weekMap = new Map([
    ['1', i18n.t('libs_table_render_88')],
    ['2', i18n.t('libs_table_render_89')],
    ['3', i18n.t('libs_table_render_90')],
    ['4', i18n.t('libs_table_render_91')],
    ["5", i18n.t('libs_table_render_92')],
    ['6', i18n.t('libs_table_render_93')],
    ['7', i18n.t('libs_table_render_94')],
  ])
  return weekMap.get(week)
}
export const scoreRewardcCategoryText = (category) => {
  const categoryMap = new Map([
    ['vip_day', i18n.t('libs_table_render_95')],
    ['birthday', i18n.t('libs_table_render_96')],
    ['anniversary', i18n.t('libs_table_render_97')],
  ])
  return categoryMap.get(category)
}

export const toggleRunButtonInTable = (vm, h, params) => {
  const nextAction = params.row.is_running ? '停用' : i18n.t('libs_table_render_98');
  return h(
    'Poptip',
    {
      props: {
        confirm: true,
        title: i18n.t('libs_table_render_99', [nextAction]),
        transfer: true
      },
      on: {
        'on-ok': () => {
          vm.toggleRunning(params.row)
        }
      }
    },
    [
      h(
        'Button',
        {
          style: {
            margin: '0 5px'
          },
          props: {
            type: nextAction === i18n.t('libs_table_render_100') ? 'default' : 'success',
            placement: 'top'
          }
        },
        nextAction
      )
    ]
  )
}

export const downloadImgInTable = (vm, h, params) => {
  return h(
    'Button',
    {
      props: {
        type: 'success'
      },
      style: {
        margin: '2px 5px'
      },
      on: {
        click: () => {
          downloadImg(params.url)
        }
      }
    },
    params.title || i18n.t('libs_table_render_101')
  )
}
